import Interaction from "../../../models/interactions/Interaction";

export default function LoseCustomQuizStarNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  return <div className="w-full h-full"></div>;
}
